import { RUNNING_ON_DEV_SERVER } from "."


const firebase_config = function () {
  if (RUNNING_ON_DEV_SERVER) {
    // DEV
    return {
      apiKey: 'AIzaSyBAu4ysgAKaYcVzroMQVOjIgboiU_u0cvQ',
      authDomain: 'renderro-dev.firebaseapp.com',
      databaseURL: 'https://renderro-dev.firebaseio.com',
      projectId: 'renderro-dev',
      storageBucket: 'renderro-dev.appspot.com',
      messagingSenderId: '1009752296330',
      appId: '1:1009752296330:web:501a0ab63c46ed69095673',
      measurementId: 'G-XP3HBYG08N',
    }
  }
  //PROD
  return {
    apiKey: 'AIzaSyAakZ0B-dmIgTpqIKH3ZAKURJQpf_LQh5I',
    authDomain: 'renderro-mvp.firebaseapp.com',
    databaseURL: 'https://renderro-mvp.firebaseio.com',
    projectId: 'renderro-mvp',
    storageBucket: 'renderro-mvp.appspot.com',
    messagingSenderId: '596125854993',
    appId: '1:596125854993:web:41957549a3a0d2aba1b0b0',
    measurementId: 'G-XP3HBYG08N',
  }
}

export default firebase_config()
